// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1380) return "static/chunks/1380-f1c05c77b0443581.js";
	// return url for filenames based on template
	return "static/chunks/" + {"1133":"datadogRecorder","9050":"datadogProfiler"}[chunkId] + "." + {"1133":"85f37994fb014a52","9050":"2455fe2cf363227c"}[chunkId] + ".js";
};